import { c as _c } from "react/compiler-runtime";
import type * as React from "react";
import { Eyebrow, Subtitle, Title } from "~/components/ui/Typography";
import { cn } from "~/lib/utils";
type SectionHeaderProps = {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: string;
  className?: string;
  eyebrowClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  align?: "left" | "center";
};
export function SectionHeader(t0) {
  const $ = _c(21);
  const {
    eyebrow,
    title,
    subtitle,
    className,
    eyebrowClassName,
    titleClassName,
    subtitleClassName,
    align: t1
  } = t0;
  const align = t1 === undefined ? "center" : t1;
  const isCenter = align === "center";
  const t2 = isCenter && "text-center";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("mb-[52px]", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== eyebrow || $[4] !== eyebrowClassName) {
    t4 = eyebrow && <Eyebrow className={cn("mb-2", eyebrowClassName)}>{eyebrow}</Eyebrow>;
    $[3] = eyebrow;
    $[4] = eyebrowClassName;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== titleClassName) {
    t5 = cn("mb-3", titleClassName);
    $[6] = titleClassName;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5 || $[9] !== title) {
    t6 = <Title size="section" className={t5}>{title}</Title>;
    $[8] = t5;
    $[9] = title;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== align || $[12] !== isCenter || $[13] !== subtitle || $[14] !== subtitleClassName) {
    t7 = subtitle && <Subtitle align={align} maxWidth={isCenter ? "md" : "none"} className={cn(isCenter && "mx-auto", subtitleClassName)}>{subtitle}</Subtitle>;
    $[11] = align;
    $[12] = isCenter;
    $[13] = subtitle;
    $[14] = subtitleClassName;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className={t3}>{t4}{t6}{t7}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}